





















import { Vue, Component, Prop } from 'vue-property-decorator';
import { ESidebarOptionType } from '@signing-page/documents/types/enums/sidebar-option-type.ts';
import { IDocumentOption } from '@signing-page/documents/types/document-option';
import { sidebarDocumentOptions } from '@signing-page/documents/constants/document-options';
import MainMenuButton from '@signing-page/documents/components/MainMenuButton.vue';
import { EDocumentStatus } from '@signing-page/documents/types/enums/document-status';
import { IRecipient } from '@/types/Recipient';
import MobileMenu from '@signing-page/common/components/MobileMenu.vue';

@Component({
  components: {
    MobileMenu,
    MainMenuButton,
  },
  data: () => ({
    ESidebarOptionType,
  }),
})
export default class MainMenu extends Vue {
  @Prop() status: EDocumentStatus;
  @Prop() documentExtractable: boolean;
  @Prop() newCommentsCount: number;
  @Prop() recipients: IRecipient[];
  @Prop() activeTwilioIntegration: boolean;
  @Prop() isPreview: boolean;
  @Prop() chatEnabled: boolean;
  @Prop() showReject: boolean;

  showOption(option: IDocumentOption): boolean {
    switch (option.type) {
      case ESidebarOptionType.Call:
        return this.activeTwilioIntegration;
      case ESidebarOptionType.Chat:
        return this.chatEnabled;
      case ESidebarOptionType.Reject:
        return this.showReject;
      case ESidebarOptionType.Download:
      case ESidebarOptionType.Print:
        return this.documentExtractable;
      default:
        return true;
    }
  }

  get menuOptions(): IDocumentOption[] {
    return sidebarDocumentOptions.filter(this.showOption);
  }

  handleMenuClick(optionType: ESidebarOptionType) {
    this.$emit('select', optionType);
    this.handleClose();
  }

  handleClose() {
    this.$emit('close');
  }
}
